module.exports = __webpack_public_path__ + "assets/Social-instagram-accent.4c7a99a2.svg";